import React from "react";
import { Stack, Typography } from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";

interface Props {}

const WhyChooseContent = (props: Props) => {
	return (
		<Stack spacing={2}>
			<Typography variant="body2" color="text.secondary">
				Tạo ít nhất 2 lợi ích và tối đa 4.
			</Typography>
			<Field.Text name="stepResource.whyChooses[0]" label="Lợi ích 1" />
			<Field.Text name="stepResource.whyChooses[1]" label="Lợi ích 2" />
			<Field.Text name="stepResource.whyChooses[2]" label="Lợi ích 3" />
			<Field.Text name="stepResource.whyChooses[3]" label="Lợi ích 4" />
		</Stack>
	);
};

export default WhyChooseContent;
